<template>
  <div class="con-wrap">
    <div class="top">
      <el-button type="primary" @click="goback">返回</el-button>
    </div>
    <div class="con-wrap-inner">
      <el-aside width="280px" style="height: auto">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">{{ areaTitle }}</div>
          </el-col>
          <el-col :span="2" :offset="6"></el-col>
        </el-row>
        <div>
          <div class="custom-tree-container">
            <div class="block">
              <el-tree
                :data="deptTreeData"
                node-key="id"
                @node-click="clickDept"
                ref="tree"
                default-expand-all
                highlight-current
                :expand-on-click-node="false"
              >
                <span class="custom-tree-node is-show" slot-scope="{ node }">
                  <span>{{ node.label }}</span>
                </span>
              </el-tree>
            </div>
          </div>
        </div>
      </el-aside>

      <el-aside width="280px">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">{{ groupTitle }}</div>
          </el-col>
          <el-col :span="2" :offset="6">
            <div
              class="grid-content bg-purple iconfont icon-add"
              style="cursor: pointer"
              @click="addGroup"
              v-if="hasPerm('maintain:dept:group:save')"
            ></div>
          </el-col>
        </el-row>
        <div>
          <ul class="group-list">
            <li
              v-for="item in groupList"
              class="is-show group-list-con"
              :class="{ active: flag == item.groupId }"
              :key="item.groupId"
              @click="getUserList(item)"
            >
              <span class="postName">{{ item.name }}</span>
              <span style="display: none">
                <span
                  @click="editGroup(item)"
                  v-if="hasPerm('maintain:dept:group:update')"
                  class="iconfont icon-edit"
                ></span>
                <span
                  @click="romoveGroup(item)"
                  v-if="hasPerm('maintain:dept:group:delete')"
                  class="iconfont icon-delete"
                ></span>
              </span>
            </li>
          </ul>
        </div>
      </el-aside>

      <el-container style="flex-direction: column">
        <el-row class="title" :gutter="20">
          <el-col :span="16">
            <div class="grid-content bg-purple">{{ userTitle }}</div>
          </el-col>
          <el-col :span="6" :offset="2">
            <div
              class="title-edit"
              style="float: right"
              @click="editUser"
              v-if="hasPerm('maintain:dept:group:edit')"
            >
              <i class="iconfont icon-edit"></i>
              {{ editTitle }}
            </div>
          </el-col>
        </el-row>
        <div style="display: block">
          <span v-for="item in UserList" :key="item.personnelId" class="tag">{{
            item.name
          }}</span>
        </div>
      </el-container>

      <!-- 运维小组弹框 -->
      <el-dialog
        :title="groupTitle"
        :visible.sync="groupVisible"
        class="mini-dialog"
      >
        <el-form
          :rules="groupTitle == '新增班组' ? rules : groupRules"
          ref="groupForm"
          :model="groupForm"
          size="mini"
          :inline="true"
        >
          <el-form-item prop="name" :label="groupName">
            <el-input
              v-model="groupForm.name"
              :placeholder="groupPlaceholder"
            ></el-input>
          </el-form-item>
        </el-form>
        <span slot="footer" class="dialog-footer">
          <el-button @click="groupVisible = false">取 消</el-button>
          <el-button type="primary" @click="groupSubmit">确 定</el-button>
        </span>
      </el-dialog>
      <!-- 运维人员弹框 -->
      <el-dialog
        :title="userTitle"
        :visible.sync="userVisible"
        class="transfer-dialog"
      >
        <user-transfer
          :leftTitle="leftTitle"
          :rightTitle="rightTitle"
          listName="name"
          listId="personnelId"
          :leftList="UserList"
          :rightList="unUserList"
          @clickLeft="addLeft"
          @clickRight="addRight"
        ></user-transfer>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import UserTransfer from "../../../components/UserTransfer.vue";
export default {
  components: {
    UserTransfer,
  },
  data() {
    return {
      deptTreeData: [],
      defaultProps: {
        value: "id",
        checkStrictly: true,
      },
      groupList: [],
      groupVisible: false,
      userVisible: false,
      groupTitle: "",
      userTitle: "",
      groupForm: { name: "" },
      groupRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入岗位名称",
          },
        ],
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入班组名称",
          },
        ],
      },
      editTag: "0",
      deptId: "",
      groupId: "",
      flag: -1,
      UserList: [],
      unUserList: [],
      groupFlag: false,
      groupPlaceholder: "",
      groupName: "",
      editTitle: "",
      leftTitle: "",
      rightTitle: "",
    };
  },
  created() {
    // console.log(this.$route.params);
    if (sessionStorage.getItem("isActive") == 1) {
      this.areaTitle = "单位列表";
      this.groupTitle = "班组";
      this.userTitle = "外业人员列表";
      this.editTitle = "编辑外业人员";
    } else {
      this.areaTitle = "部门列表";
      this.groupTitle = "运维小组";
      this.userTitle = "运维人员列表";
      this.editTitle = "编辑运维人员";
    }
    if (sessionStorage.getItem("devopsDeptId")) {
      this.deptId = sessionStorage.getItem("devopsDeptId");
    }
    this.getDeptList();
  },
  watch: {
    // 根据名称筛选部门树
    // deptName (val) {
    //   this.$refs.deptTreeData.filter(val);
    // },
    // 默认点击Tree第一个节点
    deptTreeData(val) {
      let _this = this;
      if (val) {
        _this.$nextTick(() => {
          //document.querySelector(".el-tree-node__content").click()
          _this.$refs.tree.setCurrentKey(_this.deptId);
          _this.UserList = [];
          _this.getGroupList();
          sessionStorage.setItem("devopsDeptId", _this.deptId);
        });
      }
    },
    groupList(val) {
      if (val[0]) {
        this.$nextTick(() => {
          document.querySelector(".group-list-con").click();
        });
      }
    },
  },
  methods: {
    goback() {
      // 判断是否从单位管理页面进入
      if (sessionStorage.getItem("isActive") == 0) {
        this.$router.push("/DevopsDept");
      } else {
        this.$router.push("/UnitManagement");
      }
    },
    async getDeptList() {
      let _this = this;
      let { data: res } = await _this.$axios.get("/api/sys/dept/list");
      if (res.code == 1) {
        _this.deptTreeData = res.data;
        //_this.deptId = res.data[0].id
      } else {
        _this.$message.warning(res.msg);
      }
    },
    clickDept(deptDatas) {
      this.deptId = deptDatas.id;
      sessionStorage.setItem("devopsDeptId", this.deptId);
      this.UserList = [];
      this.getGroupList();
    },
    async getGroupList() {
      let _this = this;
      let deptId = this.deptId;
      let parm = {
        deptId: deptId,
      };
      let { data: res } = await _this.$axios.get(
        "/api/maintain/dept/group/list",
        {
          params: parm,
        }
      );
      if (res.code == 1) {
        _this.groupList = res.data;
        if (res.data.length != 0) {
          _this.groupFlag = true;
        } else {
          _this.groupFlag = false;
        }
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async getUserList(data) {
      let _this = this;
      _this.flag = data.groupId;
      _this.groupId = data.groupId;
      let parm = {
        groupId: data.groupId,
        range: 1,
      };
      let { data: res } = await _this.$axios.get("/api/maintain/dept/options", {
        params: parm,
      });
      if (res.code == 1) {
        _this.UserList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    addGroup() {
      this.editTag = "0";
      this.$resetForm(this, "groupForm");
      if (sessionStorage.getItem("isActive") == 1) {
        this.groupTitle = "新增班组";
        this.groupPlaceholder = "请输入班组名称";
        this.groupName = "班组名称";
      } else {
        this.groupTitle = "新增运维小组";
        this.groupPlaceholder = "请输入运维小组名称";
        this.groupName = "小组名称";
      }
      this.groupVisible = true;
    },
    editGroup(item) {
      this.editTag = "1";
      this.$resetForm(this, "groupForm");
      if (sessionStorage.getItem("isActive") == 1) {
        this.groupTitle = "修改班组名称";
      } else {
        this.groupTitle = "修改运维小组";
      }

      this.groupVisible = true;
      this.groupId = item.groupId;
      this.groupForm.name = item.name;
    },
    groupSubmit() {
      let _this = this;
      let parm = {};
      if (_this.editTag == "0") {
        parm = {
          deptId: _this.deptId,
          name: _this.groupForm.name,
        };
      } else {
        parm = {
          groupId: _this.groupId,
          name: _this.groupForm.name,
        };
      }

      let data = [];
      _this.$refs.groupForm.validate(async (valid) => {
        if (valid) {
          if (_this.editTag == "0") {
            data = await _this.$axios.post("/api/maintain/dept/group", parm);
          } else {
            data = await _this.$axios.patch("/api/maintain/dept/group", parm);
          }
          let res = data.data;
          if (res.code == 1) {
            _this.$message.success("操作成功");
            _this.getGroupList();
            _this.groupVisible = false;
          } else {
            _this.$message.warning(res.msg);
          }
        }
      });
    },
    romoveGroup(item) {
      let _this = this;
      let groupId = item.groupId;
      _this
        .$confirm("确定删除吗？", "系统提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
        .then(async () => {
          let { data: res } = await _this.$axios.delete(
            "/api/maintain/dept/group/" + groupId
          );
          if (res.code == 1) {
            _this.$message.success("操作成功");
            _this.getGroupList();
          } else {
            _this.$message.warning(res.msg);
          }
        });
    },
    editUser() {
      console.log(!this.groupFlag);
      if (!this.groupFlag) {
        if (sessionStorage.getItem("isActive") == 1) {
          this.$message.warning("请先新增班组");
        } else {
          this.$message.warning("请先新增运维小组");
        }
        return;
      }
      this.userVisible = true;
      if (sessionStorage.getItem("isActive") == 1) {
        this.userTitle = "编辑外业人员";
        this.leftTitle = "已选择外业人员";
        this.rightTitle = "未选择外业人员";
      } else {
        this.userTitle = "编辑运维人员";
        this.leftTitle = "已选择运维人员";
        this.rightTitle = "未选择运维人员";
      }

      this.getUnselectUser();
    },
    async getUnselectUser() {
      let _this = this;
      let parm = {
        groupId: _this.groupId,
        range: 2,
      };
      let { data: res } = await _this.$axios.get("/api/maintain/dept/options", {
        params: parm,
      });
      if (res.code == 1) {
        _this.unUserList = res.data;
      } else {
        _this.$message.warning(res.msg);
      }
    },
    async addRight(selectForm) {
      let parm = {
        deptId: this.deptId,
        operating: 2,
        groupId: this.groupId,
        personnelId: selectForm,
      };
      this.reviseUserRely(parm);
    },
    async addLeft(unselectForm) {
      let parm = {
        deptId: this.deptId,
        operating: 1,
        groupId: this.groupId,
        personnelId: unselectForm,
      };
      this.reviseUserRely(parm);
    },
    async reviseUserRely(parm) {
      let _this = this;
      let { data: res } = await _this.$axios.patch(
        "/api/maintain/dept/group/edit",
        parm
      );
      if (res.code == 1) {
        //信息提示
        _this.$message.success("操作成功");
        //刷新部门树
        _this.getUnselectUser();
        _this.getUserList(parm);
      } else {
        _this.$message.warning(res.msg);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.top {
  height: 48px;
  line-height: 48px;
  display: block;
  margin-bottom: 20px;
  padding-left: 20px;
  background-color: #fff;
}
.con-wrap-inner {
  width: 100%;
  height: calc(100% - 68px);
  display: flex;
  flex-direction: row;
  background-color: #f8f8f8;
}
.con-wrap-inner .el-container {
  background-color: #fff;
}
.title-edit {
  cursor: pointer;
}
.title-edit:hover {
  color: #0094ff;
}
.is-show:hover :nth-child(2) {
  display: inline-block !important;
}
.group-list {
  position: relative;
  cursor: default;
  background: #fff;
  color: #606266;
}
.group-list .is-show {
  height: 28px;
  line-height: 28px;
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding: 0 14px;
  cursor: pointer;
}
.group-list .is-show:hover {
  background: #f5f7fa;
}
.group-list .active {
  background: #ddf0fe !important;
  color: #0094ff;
}
.tag {
  display: inline-block;
  width: 120px;
  height: 32px;
  line-height: 32px;
  text-align: center;
  margin: 10px;
  font-size: 14px;
  color: #333;
  border-radius: 4px;
  background-color: #ddf0fe;
}
</style>
